<script>
export default {
  name: 'HomeHeading',
};
</script>

<template lang="pug">
  h1.p-home-heading
    |Chinggo
    br
    |Gecenin Şekil Almış Haliyim
</template>

<style lang="scss">
.p-home-heading {
  display: none;
}
</style>
